import { useContext, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import logoSmall from "../../../assets/custom/classic/logo_login_small.png";
import { ICountry, IForgotPasswordParams, IForgotPasswordRequest, IForgotState, ILogin, loginSchema } from "../../../utils/types";
import LoginUsernameInput from "./components/LoginUsernameInput";
import LoginPasswordInput from "./components/LoginPasswordInput";
import LoginButton from "./components/LoginButton";
import LoginTerm from "./components/LoginTerm";
import Loading from "../../components/Loading";
import AlertErro from "../../components/AlertErro";
import { UiContext } from "../../../context/UiContext";

import { useAuth } from "../../../context/useAuth";
import { useTranslation } from "react-i18next";
import "../stylePage.css";
import Home from "../Home";
import * as BsIcons from "react-icons/bs";
import urlConf from "../../../utils/urlTem";
import {
  geti18nextLngLocalStorage,
  getlangStorage,
} from "../../../context/utils";
import { UserPreferenceContext } from "../../../context/UserPreferenceContext";
import {
  getUrlTerm,
  handleChangeAux,
  handleForgotPassword,
  loadDefinitionsAuthStorage,
} from "./LoginUtils";
import i18next from "i18next";
import ForgotPasswordForm from "./ForgotPasswordForm";
import { Link, useLocation, useNavigate } from "react-router-dom";

const styleForLink = {
  textDecoration: "none",
  color: "#fff",
  borderBottom: "1px solid white",
  cursor: "pointer",
};

const Login = ({ countries }: { countries: ICountry[] }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const { userAuthenticated, userMenssageApi } = useContext(
    UserPreferenceContext
  );

  const [user, setUser] = useState<ILogin>(() => {
    const keepConnectedStorage = localStorage.getItem("keepConnected");
    const termsStorage = localStorage.getItem("terms");
    
    let savedKeepConnected = false;
    let savedTerms = false;
    
    if (keepConnectedStorage) {
      savedKeepConnected = JSON.parse(keepConnectedStorage);
    }
    
    if (savedKeepConnected && termsStorage) {
      savedTerms = JSON.parse(termsStorage);
    }
    
    return {
      username: "",
      password: "",
      keepConnected: savedKeepConnected,
      terms: savedTerms,
      countryId: 1,
      language: i18next?.language ?? geti18nextLngLocalStorage() ?? "pt-BR",
  } as ILogin});

  const [errorLogin, setErrorLogin] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const auth = useAuth();

  const [urlTerm, setUrlTerm] = useState<string>("");
  const [clickedForgot, setClickedForgot] = useState<boolean>(false);

  const [loadingForgot, setLoadingForgot] = useState<boolean>(false);

  const { isMobile } = useContext(UiContext);

useEffect(() => {
    localStorage.setItem("keepConnected", JSON.stringify(user.keepConnected));
    
    if (user.keepConnected) {
      localStorage.setItem("terms", JSON.stringify(user.terms));
      localStorage.setItem("rememberLogin", "true");
    } else {
      localStorage.removeItem("terms");
      localStorage.removeItem("rememberLogin");
      localStorage.removeItem("UserAuth");
    }
  }, [user.keepConnected]);

  useEffect(() => {
    if (user.keepConnected) {
      localStorage.setItem("terms", JSON.stringify(user.terms));
    }
  }, [user.terms, user.keepConnected]);

  useEffect(() => {
    handleLoadChangePassword();
  });

  useEffect(() => {
    loadUrlTerm();
  }, [countries]);

  // Sincronizar countryId com o valor do select quando countries carrega
  useEffect(() => {
    if (countries && countries.length > 0) {
      // Pega o valor atual do select
      const selectElement = document.getElementById('fieldCountryId') as HTMLSelectElement;
      if (selectElement && selectElement.value) {
        const currentCountryId = Number(selectElement.value);

        // Só atualiza se for diferente do valor atual
        if (currentCountryId !== user.countryId) {
          setUser(prev => ({ ...prev, countryId: currentCountryId }));
        }
      } else if (countries.length > 0) {
        // Se não conseguir pegar do select, usa o primeiro país da lista
        const firstCountryId = countries[0].CountryID;
        if (firstCountryId !== user.countryId) {
          setUser(prev => ({ ...prev, countryId: firstCountryId }));
        }
      }
    }
  }, [countries, user.countryId]);

  useEffect(() => {
    loadLogin();
  }, [userAuthenticated, userMenssageApi]);

  async function loadLogin() {
    loadDefinitionsAuthStorage(setUser);
    handleChangeLanguage("language", getlangStorage());
    if (userMenssageApi) {
      setErrorLogin(userMenssageApi);
    }
  }
  async function handleLogin() {
    setErrorLogin("");
    setLoading(true);

    try {
      const value = await loginSchema.validate(user);
      if (value) {
        await handleAuth();
      }
    } catch (err) {
      if (err instanceof Error) {
        if (err.message.includes("password")) {
          setErrorLogin(t("password.maxCharacters"));
        } else {
          setErrorLogin(t("login.maxCharacters"));
        }
      }
    } finally {
      setLoading(false);
    }
  }
  async function handleAuth() {
    const response = await auth.authenticate(
      user.username,
      user.password,
      user.countryId,
      user.language ?? geti18nextLngLocalStorage() ?? "pt-BR",
      user.keepConnected ?? false,
      user.terms ?? false
    );
    const resposeResult = await response;
    let resposeResultText: string = resposeResult.toString();
    if (await (!response || response.error)) {
      if (response.error == "password_expired") {
        navigate("/changepassword", { state: { error: response.error_description, username: user.username, countryId: user.countryId } });
      } else {
        setErrorLogin(response.error_description)
      }

    } else if (
      resposeResult.error?.status === 500 ||
      resposeResultText.indexOf("One or more errors occurred.") >= 0
    ) {
      setErrorLogin(t("login.errorApi"));
    } else {
      navigate("/");
    }
  }

  if (userAuthenticated === true) return <Home />;

  if (!countries || countries.length === 0) return <Loading show={true} isMobile={isMobile} />;

  async function loadUrlTerm() {
    if (countries && countries.length > 0) {
      let urlTerm = getUrlTerm(user, countries, urlConf, handleChange);
      setUrlTerm(urlTerm);
      if (user.countryId === 0) {
        let newUser = { ...user };
        newUser.countryId = countries[0].CountryID;
        setUser(newUser);
      }
    } else if (user.countryId === 0) {
      let newUser = { ...user };
      newUser.countryId = 1;
      setUser(newUser);
    }
  }
  async function handleChangeLanguage(field: string, value: any) {
    handleChangeAux(field, value, getlangStorage, setUser, i18n, setErrorLogin);
  }
  async function handleChangeCountry(field: string, value: any) {
    if (value) {
      setUser((prev) => ({ ...prev, [field]: Number(value) }));
      await loadUrlTerm();
    }
  }
  async function handleChange(field: string, value: any) {
    setUser((prev) => ({ ...prev, [field]: value }));
  }
  async function handleLoadChangePassword() {
    if (loadingForgot === false) {
      const paramsGet: IForgotPasswordParams[] = [
        { key: "token", value: null },
        { key: "language", value: null },
      ];
      const restfp: IForgotPasswordRequest = {
        location,
        navigate,
        searchParam: "path",
        pathToCheck: "forgotPassword",
        pathToRedirect: "/changepassword",
        paramsGet,
      };
      handleForgotPassword(restfp);
    }
    setLoadingForgot(true);
  }

  if (clickedForgot) {
    const forgotState: IForgotState = {
      clickedForgot,
      setClickedForgot,
    };
    return (
      <ForgotPasswordForm countries={countries} forgotState={forgotState} />
    );
  }

  return (
    <Col className="loginDiv" style={{ display: isMobile ? "block" : "flex", justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <img
        src={logoSmall}
        style={{ width: "320px", height: "30px" }}
        alt="Kantar Ibope Media"
      />

      <form style={{ paddingBottom: "40px" }}>

        <fieldset className="loginFieldset">
          <legend className="loginFieldsetLegend">{t("login.welcome")}</legend>
          <Row>
            <LoginUsernameInput
              login={user}
              handleChange={handleChange}
              placeholder={t("login.username")}
            />
          </Row>
          <Row>
            <LoginPasswordInput
              login={user}
              handleChange={handleChange}
              placeholder={t("login.password")}
            />
          </Row>
          <Row>
            <Col>
              <div>
                <div style={{
                  width: "115px",
                  height: "30px",
                  fontSize: "14px",
                  border: "1px solid #c7c7cc",
                  borderRadius: "5px",
                  float: "left",
                  marginRight: "10px",
                  overflow: "hidden"
                }}>
                  <Form.Select id="fieldCountryId"
                    onChange={(e) => {
                      handleChangeCountry("countryId", e.target.value);
                    }}
                    value={user.countryId}
                    style={{
                      border: 0,
                      height: "42px",
                      marginTop: "-6px",
                      marginLeft: "-5px",
                      width: "141px",
                      background: "#fff",
                      paddingLeft: "8px",
                      fontSize: "13px",
                    }}
                  >
                    {countries.map((option) => (
                      <option key={option.CountryID} value={option.CountryID}>
                        {option.CountryDesc}
                      </option>
                    ))}
                  </Form.Select>
                </div>
                <div style={{ display: "contents" }}>
                  <span style={{ fontSize: "15px", lineHeight: "27px" }}>
                    <button
                      style={{
                        textDecoration: "underline",
                        color: "white",
                        border: "none",
                        cursor: "pointer",
                        background: "none"
                      }}
                      onClick={() => setClickedForgot(true)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          setClickedForgot(true);
                        }
                      }}
                    >
                      {t("password.forgotPasswordLink")}
                    </button>
                  </span>
                </div>
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "5px" }}>
            <Col>
              <Link to="#">
                <div>
                  <BsIcons.BsCheck
                    className={
                      user.keepConnected === false
                        ? "no-checked-input"
                        : "checked-input"
                    }
                    onClick={() =>
                      handleChange("keepConnected", !user.keepConnected)
                    }
                  />
                  <label
                    htmlFor="keepConnected"
                    className="form-check-label"
                    style={{ color: "white" }}
                  >
                    {t("login.saveInfo")}
                  </label>
                </div>
              </Link>
            </Col>
          </Row>
        </fieldset>
        <Row>
          <Col>
            <AlertErro text={errorLogin} setShow={setErrorLogin} />
          </Col>
        </Row>
        <Row>
          <Col>
            <Link to="#">
              <BsIcons.BsCheck
                className={
                  user.terms === false ? "no-checked-input" : "checked-input"
                }
                onClick={() => handleChange("terms", !user.terms)}
              />
            </Link>
            <LoginTerm
              handleChange={handleChange}
              login={user}
              urlTerm={urlTerm}
              styleForLink={styleForLink}
              textReadAndAgree={t("login.iAgree")}
              textTerm={t("login.tos")}
            />
          </Col>
        </Row>
        <LoginButton
          login={user}
          loading={loading}
          handleClick={handleLogin}
          t={t}
        />
      </form>
    </Col>

  );
};

export default Login;
